module.exports = __webpack_public_path__ + "static/media/leafly-grey.68dbeeba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/leafly-grey.svg
// module id = 2438
// module chunks = 0